const onDocumentReadyAndWindowResize = () => {
    const buttons = document.querySelectorAll('.shop-by-brand-listing-li');
    const sections = document.querySelectorAll('.shop-by-brand-alphabet-block');
    const headerHeight = document.querySelector('.site-header').offsetHeight;
    const alphabettopHeight = document.querySelector('.shop-by-brand-top-section').offsetHeight;

    document.querySelector(".shop-by-brand-top-section").style.top = headerHeight + "px";

    buttons.forEach(button => {
        if (!document.querySelector(button.getAttribute('data-target'))) {
            button.style.opacity = "0.5";
            button.style.pointerEvents = "none";
        }
        button.addEventListener('click', () => {
            const target = document.querySelector(button.getAttribute('data-target'));
            if (target) {
                const targetPosition = target.getBoundingClientRect().top + window.scrollY - 150;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            } else {
                console.error('Target not found:', button.getAttribute('data-target'));
            }
        });

        // Handle keydown event for keyboard navigation
        button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const target = document.querySelector(button.getAttribute('data-target'));
                if (target) {
                    const targetPosition = target.getBoundingClientRect().top + window.scrollY - 150;
                    window.scrollTo({
                        top: targetPosition,
                        behavior: 'smooth'
                    });
                } else {
                    console.error('Target not found:', button.getAttribute('data-target'));
                }
            }
        });
    });

    const highlightActiveAlphabet = () => {
        let current = '';
        const viewportHeight = window.innerHeight;

        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            const sectionBottom = sectionTop + section.clientHeight;

            if (window.scrollY >= sectionTop - (alphabettopHeight + headerHeight + 30) && window.scrollY < sectionBottom - (alphabettopHeight + headerHeight + 30)) {
                current = section.getAttribute('id');
            }
        });

        buttons.forEach(button => {
            button.classList.remove('active');
            if (button.getAttribute('data-target') === `#${current}`) {
                button.classList.add('active');
            }
        });
    }
    highlightActiveAlphabet();
    window.addEventListener('scroll', highlightActiveAlphabet);
};
// Execute the function when the document is fully loaded
document.addEventListener('DOMContentLoaded', onDocumentReadyAndWindowResize);

// Execute the function when the window is resized
window.addEventListener('resize', onDocumentReadyAndWindowResize);